const objectGetPropUtil = (obj: any, path: string): any =>
  path.split('.').reduce((acc, part) => {
    if (acc && typeof acc === 'object') {
      // This one is needed because of the way translations are typed in the project
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return,@typescript-eslint/no-unsafe-member-access
      return acc[part];
    }

    return undefined;
  }, obj);

export default objectGetPropUtil;
